import { WorkerHostEndpoint } from '@wix/editor-platform-transport';
import { EditorPlatformContextEnvironment } from './EditorPlatformContextEnvironment';
import {
  createEditorPlatformEnvironmentAPIError,
  EditorPlatformEnvironmentAPIErrorErrorCode,
} from './errors';
import {
  createEditorPlatformInternalError,
  EditorPlatformInternalErrorCode,
} from '@wix/public-editor-platform-errors';
import { PlatformConsumerEnvironmentAPIType } from './api';

export class EditorPlatformEnvironmentProxy {
  async iframe() {
    throw createEditorPlatformInternalError(
      EditorPlatformInternalErrorCode.UnexpectedError,
      'not supported',
    );
  }

  async worker(worker: Worker) {
    const environment = new EditorPlatformContextEnvironment();

    if (!environment.isEnvironmentApiExposed()) {
      environment.expose();
    }

    const connectTimeoutId = setTimeout(() => {
      console.info(
        createEditorPlatformEnvironmentAPIError(
          EditorPlatformEnvironmentAPIErrorErrorCode.ProxyEnvironmentConnectTimeout,
          'probably worker environment does not expose platform API or any SDK function is never used',
        ),
      );
    }, 2_000);

    WorkerHostEndpoint.connect(worker, async (transport) => {
      clearTimeout(connectTimeoutId);

      const waitAPITimeoutId = setTimeout(() => {
        console.error(
          createEditorPlatformEnvironmentAPIError(
            EditorPlatformEnvironmentAPIErrorErrorCode.ProxyWaitAPITimeout,
          ),
        );
      }, 2_000);

      const workerApi = await transport.waitAPI(
        PlatformConsumerEnvironmentAPIType.Worker,
      );

      clearTimeout(waitAPITimeoutId);

      try {
        const contexts = await environment.getContexts();

        await workerApi.injectEnvironmentContext({
          events: contexts.environmentContext.getEvents(),
          privateApi: contexts.environmentContext.getPrivateAPI(),
          applicationAPIs: contexts.environmentContext.getApplicationAPIs(),
        });

        await workerApi.injectApplicationContext(
          contexts.applicationContext.getContext(),
        );
      } catch (e: any) {
        throw createEditorPlatformEnvironmentAPIError(
          EditorPlatformEnvironmentAPIErrorErrorCode.ProxyContextsError,
        ).withParentError(e);
      }
    });
  }
}
